/* From React starter serviceWorker */
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export let API_ROOT

if (isLocalhost) {
  // Use a relative path in development; CRA dev server will proxy this to http://localhost:8000
  // This avoids hardcoding a host:port and works when running the React dev server on :8080
  API_ROOT = "/django";
} else {
    API_ROOT = "https://gallery.dailybruin.com/django";
}

// https://gallery.dailybruin.com/django

